// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file types/v1/risk.proto (package types.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file types/v1/risk.proto.
 */
export const file_types_v1_risk: GenFile = /*@__PURE__*/
  fileDesc("ChN0eXBlcy92MS9yaXNrLnByb3RvEgh0eXBlcy52MSpUCghSaXNrVHlwZRIZChVSSVNLX1RZUEVfVU5TUEVDSUZJRUQQABIUChBSSVNLX1RZUEVfQ1JFRElUEAESFwoTUklTS19UWVBFX0xJUVVJRElUWRACKpABCgxNVE1Vc2FnZVR5cGUSHgoaTVRNX1VTQUdFX1RZUEVfVU5TUEVDSUZJRUQQABIdChlNVE1fVVNBR0VfVFlQRV9BQ0NPVU5USU5HEAESHAoYTVRNX1VTQUdFX1RZUEVfTElRVUlESVRZEAISIwofTVRNX1VTQUdFX1RZUEVfUEVSX09SR0FOSVpBVElPThADKmsKDk1UTVBlcnNwZWN0aXZlEh8KG01UTV9QRVJTUEVDVElWRV9VTlNQRUNJRklFRBAAEhoKFk1UTV9QRVJTUEVDVElWRV9FQ0xFQVIQARIcChhNVE1fUEVSU1BFQ1RJVkVfQ1VTVE9NRVIQAiqPAQoVUmlza0NhbGN1bGF0aW9uVGFyZ2V0EicKI1JJU0tfQ0FMQ1VMQVRJT05fVEFSR0VUX1VOU1BFQ0lGSUVEEAASHwobUklTS19DQUxDVUxBVElPTl9UQVJHRVRfQUxMEAESLAooUklTS19DQUxDVUxBVElPTl9UQVJHRVRfUEhZU0lDQUxfRlVUVVJFUxACKqsBCgpSZXN1bHRUeXBlEhsKF1JFU1VMVF9UWVBFX1VOU1BFQ0lGSUVEEAASFgoSUkVTVUxUX1RZUEVfTk9fTVRNEAESEwoPUkVTVUxUX1RZUEVfTVRNEAISFAoQUkVTVUxUX1RZUEVfSkVQWBADEh4KGlJFU1VMVF9UWVBFX01UTV9XSVRIX1BPV0VSEAQSHQoZUkVTVUxUX1RZUEVfTElRVUlESVRZX1BGRRAFQp4BCgxjb20udHlwZXMudjFCCVJpc2tQcm90b1ABWkJnaXRodWIuY29tL2VuZWNoYWluL2Vwb3NpdGlvbi1hcHAvYmFja2VuZC9nZW4vcHJvdG8vdHlwZXMvdjE7dHlwZXOiAgNUWFiqAghUeXBlcy5WMcoCCFR5cGVzXFYx4gIUVHlwZXNcVjFcR1BCTWV0YWRhdGHqAglUeXBlczo6VjFiBnByb3RvMw");

/**
 * @generated from enum types.v1.RiskType
 */
export enum RiskType {
  /**
   * @generated from enum value: RISK_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 信用リスク
   *
   * @generated from enum value: RISK_TYPE_CREDIT = 1;
   */
  CREDIT = 1,

  /**
   * 資金流動性リスク
   *
   * @generated from enum value: RISK_TYPE_LIQUIDITY = 2;
   */
  LIQUIDITY = 2,
}

/**
 * Describes the enum types.v1.RiskType.
 */
export const RiskTypeSchema: GenEnum<RiskType> = /*@__PURE__*/
  enumDesc(file_types_v1_risk, 0);

/**
 * @generated from enum types.v1.MTMUsageType
 */
export enum MTMUsageType {
  /**
   * @generated from enum value: MTM_USAGE_TYPE_UNSPECIFIED = 0;
   */
  MTM_USAGE_TYPE_UNSPECIFIED = 0,

  /**
   * 会計用・市場リスク
   *
   * @generated from enum value: MTM_USAGE_TYPE_ACCOUNTING = 1;
   */
  MTM_USAGE_TYPE_ACCOUNTING = 1,

  /**
   * 流動性リスク
   *
   * @generated from enum value: MTM_USAGE_TYPE_LIQUIDITY = 2;
   */
  MTM_USAGE_TYPE_LIQUIDITY = 2,

  /**
   * 個社管理
   *
   * @generated from enum value: MTM_USAGE_TYPE_PER_ORGANIZATION = 3;
   */
  MTM_USAGE_TYPE_PER_ORGANIZATION = 3,
}

/**
 * Describes the enum types.v1.MTMUsageType.
 */
export const MTMUsageTypeSchema: GenEnum<MTMUsageType> = /*@__PURE__*/
  enumDesc(file_types_v1_risk, 1);

/**
 * @generated from enum types.v1.MTMPerspective
 */
export enum MTMPerspective {
  /**
   * @generated from enum value: MTM_PERSPECTIVE_UNSPECIFIED = 0;
   */
  MTM_PERSPECTIVE_UNSPECIFIED = 0,

  /**
   * @generated from enum value: MTM_PERSPECTIVE_ECLEAR = 1;
   */
  MTM_PERSPECTIVE_ECLEAR = 1,

  /**
   * @generated from enum value: MTM_PERSPECTIVE_CUSTOMER = 2;
   */
  MTM_PERSPECTIVE_CUSTOMER = 2,
}

/**
 * Describes the enum types.v1.MTMPerspective.
 */
export const MTMPerspectiveSchema: GenEnum<MTMPerspective> = /*@__PURE__*/
  enumDesc(file_types_v1_risk, 2);

/**
 * @generated from enum types.v1.RiskCalculationTarget
 */
export enum RiskCalculationTarget {
  /**
   * @generated from enum value: RISK_CALCULATION_TARGET_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: RISK_CALCULATION_TARGET_ALL = 1;
   */
  ALL = 1,

  /**
   * @generated from enum value: RISK_CALCULATION_TARGET_PHYSICAL_FUTURES = 2;
   */
  PHYSICAL_FUTURES = 2,
}

/**
 * Describes the enum types.v1.RiskCalculationTarget.
 */
export const RiskCalculationTargetSchema: GenEnum<RiskCalculationTarget> = /*@__PURE__*/
  enumDesc(file_types_v1_risk, 3);

/**
 * @generated from enum types.v1.ResultType
 */
export enum ResultType {
  /**
   * @generated from enum value: RESULT_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: RESULT_TYPE_NO_MTM = 1;
   */
  NO_MTM = 1,

  /**
   * @generated from enum value: RESULT_TYPE_MTM = 2;
   */
  MTM = 2,

  /**
   * @generated from enum value: RESULT_TYPE_JEPX = 3;
   */
  JEPX = 3,

  /**
   * @generated from enum value: RESULT_TYPE_MTM_WITH_POWER = 4;
   */
  MTM_WITH_POWER = 4,

  /**
   * @generated from enum value: RESULT_TYPE_LIQUIDITY_PFE = 5;
   */
  LIQUIDITY_PFE = 5,
}

/**
 * Describes the enum types.v1.ResultType.
 */
export const ResultTypeSchema: GenEnum<ResultType> = /*@__PURE__*/
  enumDesc(file_types_v1_risk, 4);

